'use client'
import React, { useEffect, useRef, useState } from 'react'

export default function Toast() {
  const [show, setShow] = useState(false)
  const dataRef = useRef({ message: '', heading: '', toastType: '' })
  const timeoutRef: any = useRef()
  const TIMEOUT_DURATION = 5000

  const Colors = {
    success: 'primary',
    warning: 'yellow-500',
    danger: 'danger'
  }

  useEffect(() => {
    function notify(e: any) {
      clearTimeout(timeoutRef.current)
      dataRef.current.heading = e?.detail?.heading || e?.detail?.message || ''
      dataRef.current.message = (e?.detail?.heading ? e?.detail?.message : '') || ''
      dataRef.current.toastType =
        Colors[(e?.detail?.toastType as 'success' | 'warning' | 'danger') || 'success']
      setShow(true)
      timeoutRef.current = setTimeout(() => {
        setShow(false)
      }, TIMEOUT_DURATION)
    }
    document.addEventListener('notify', notify)
    return () => {
      document.removeEventListener('notify', notify)
    }
  }, [])

  function onClose() {
    clearTimeout(timeoutRef.current)
    setShow(false)
  }
  return show ? (
    <div
      role="alert"
      className={`fixed right-5 top-10 rounded-xl bg-card border border-${dataRef.current.toastType} shadow-gray-500 text-white p-2 w-80 z-50 transition-all duration-300`}
    >
      <div className="flex items-start gap-4">
        <span className={`text-${dataRef.current.toastType}`}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-6 w-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </span>

        <div className="flex-1">
          {dataRef.current.heading ? (
            <strong className={`block font-medium text-${dataRef.current.toastType}`}>
              {' '}
              {dataRef.current.heading}{' '}
            </strong>
          ) : null}

          {dataRef.current.message ? (
            <p className="mt-0.5 text-sm text-t-700">{dataRef.current.message}</p>
          ) : null}
        </div>

        <button
          className={`transition hover:text-gray-600 text-${dataRef.current.toastType}`}
          onClick={onClose}
        >
          <span className="sr-only">Dismiss popup</span>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-6 w-6"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  ) : null
}
